<template>
    <div class="qualification-status">
        <el-button
            class="refresh-btn"
            type="text"
            icon="el-icon-refresh"
            size="mini"
            :loading="refreshLoading"
            @click="onRefresh"
        >
            刷新资质状态
        </el-button>
        <xx-form-item
            v-if="manufacturerId > 0"
            label="生产商"
        >
            {{ manufacturerName ? manufacturerName : '--' }}
            <template v-if="manufacturerStatus === 1">
                <xx-link :path="`/supplierSku/producer/edit.html?action=detail&id=${manufacturerId}`">
                    去查看
                </xx-link>
            </template>
            <template v-else>
                <el-tag
                    type="danger"
                    size="mini"
                >
                    <template v-if="manufacturerStatus === 2">
                        资质已过期
                    </template>
                    <template v-if="manufacturerStatus === 3">
                        未填写
                    </template>
                </el-tag>
                <el-tooltip
                    content="品控可能会驳回"
                    placement="top"
                >
                    <i class="el-icon-warning"></i>
                </el-tooltip>
                <xx-link :path="`/supplierSku/producer/edit.html?action=edit&id=${manufacturerId}`">
                    去修改
                </xx-link>
            </template>
        </xx-form-item>
    </div>
</template>

<script>

export default {
    name: 'QualificationStatus',
    props: {
        manufacturerId: {
            type: [Number, String],
            default: '',
        },
        manufacturerName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            manufacturerStatus: 1, // 1查看，2已过期，3未填写
            refreshLoading: false,
        };
    },
    computed: {
        trigger() {
            return [this.manufacturerId];
        },
    },
    watch: {
        trigger: {
            handler() {
                this.onRefresh();
            },
            immediate: true,
        },
    },
    methods: {
        async getManufacturerStatus() {
            if (this.manufacturerId < 1) return;
            const res = await this.$hPost('/api/vss/shepherd/sqm/producer/risk/info', {
                producerId: this.manufacturerId,
            }).catch(() => 'error');
            if (res === 'error') {
                this.manufacturerStatus = 1;
                return;
            }
            const { producerInfo = {} } = res;
            // 未填写
            if (!producerInfo.certs || !producerInfo.certs.length) {
                this.manufacturerStatus = 3;
                return;
            }
            // 资质是否过期，isLongTerm=0 非长期有效，截止日期小于当前时间
            const isExpired = producerInfo.certs.some((cert) => {
                if (cert.isLongTerm === 0 && +cert.endTime < new Date().getTime()) return true;
                return false;
            });
            if (isExpired) {
                this.manufacturerStatus = 2;
                return;
            }
            // 查看
            this.manufacturerStatus = 1;
        },
        async onRefresh() {
            try {
                this.refreshLoading = true;
                await this.getManufacturerStatus();
            } catch (error) {
                // pass
            } finally {
                this.refreshLoading = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.qualification-status {
    font-size: 14px;
    color: #585D66;
    margin-bottom: 10px;
    position: relative;
    .refresh-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10;
    }
    /deep/ .el-form-item {
        margin-bottom: 0;
    }
}
</style>
